/* eslint-disable @typescript-eslint/ban-ts-comment */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/es/symbol';
import React from 'react';
import ReactDOM from 'react-dom';
import axe from 'react-axe';
import { ThemeProvider } from '@material-ui/core';

import './index.css';
import { defaultTheme } from './styles/defaultTheme';
import App from './App';

if (process.env.NODE_ENV === 'development') {
  axe(React, ReactDOM, 1000);
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={defaultTheme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
